import * as actionsTypes from '../actions/actionsTypes';

const initialState = {
  loading: false,
  details: [],
  cast: [],
  trailers: [],
  reviews: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionsTypes.FETCH_TITLE_INFO_PENDING: {
      return {
        ...state,
        details: [],
        cast: [],
        trailers: [],
        reviews: [],
        loading: true,
      };
    }

    case actionsTypes.FETCH_TITLE_INFO_FULFILLED: {
      return {
        ...state,
        details: action.payload.details,
        cast: action.payload.cast,
        trailers: action.payload.trailers,
        reviews: action.payload.reviews,
        loading: false,
      };
    }

    default:
      return state;
  }
};

export default reducer;
